import { skeletonStyle } from "@repo/ui/Skeletons/skeletons";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";
import {
  searchModalRowIconClassName,
  searchModalRowStyle,
  searchModalRowSubtitleLineClassName,
  searchModalRowTitleLineClassName,
} from "./searchModalRow.js";

export interface SearchModalLoadingRowProps {
  /** Alternates the placeholder widths so the skeleton doesn't look striped. */
  index: number;
  showBadge: boolean;
  showTrailing: boolean;
}

/**
 * Placeholder for a `SearchModalRow`. Built from that row's own geometry —
 * icon slot, line boxes, padding — so the real row drops straight into this
 * footprint when results arrive.
 */
export const SearchModalLoadingRow: FC<SearchModalLoadingRowProps> = (
  props,
) => {
  const { index, showBadge, showTrailing } = props;
  const isWide = index % 2 === 0;

  return (
    <div className={searchModalRowStyle()}>
      <span className={searchModalRowIconClassName}>
        <span
          className={skeletonStyle({
            className: "size-4 rounded-sm bg-border-light",
          })}
        />
      </span>
      <span className="min-w-0 flex-1">
        <span className={searchModalRowTitleLineClassName}>
          <span
            className={skeletonStyle({
              className: twMerge(
                "h-3.5 rounded-sm bg-border-light",
                isWide ? "w-44" : "w-36",
              ),
            })}
          />
        </span>
        <span className={searchModalRowSubtitleLineClassName}>
          <span
            className={skeletonStyle({
              className: twMerge(
                "h-3 max-w-full rounded-sm bg-muted",
                isWide ? "w-60" : "w-48",
              ),
            })}
          />
        </span>
      </span>
      {showBadge ? (
        // Sized like the small `Pill` the loaded row uses for its badge.
        <span
          className={skeletonStyle({
            className: "h-6 w-20 shrink-0 rounded-md bg-muted",
          })}
        />
      ) : null}
      {showTrailing ? (
        <span
          className={twMerge(searchModalRowSubtitleLineClassName, "shrink-0")}
        >
          <span
            className={skeletonStyle({
              className: "h-3 w-10 rounded-sm bg-muted",
            })}
          />
        </span>
      ) : null}
    </div>
  );
};
